import React, { useState, useEffect, useContext } from "react";
import PopoverInput from "./inner/popoverInput.jsx";
import { DataSourceContext, IsMobileContext } from "../context/contexts.jsx";
 
const DepartureFooter = ({ selectedAirports, close }) => {
    return <div className="text-center">
        <button className="btn btn-pri" onClick={() => close()}>Ok</button>
    </div>;
}
const SelectItem = ({ airportCode, airportName, isSelected, onChange }) => {
    return (<div className="form-checkbox-wrapper hover:bg-content_5 rounded-[8px] mr-2 text-content_2">
        <label className="form-checkbox-label-left ">
            <input type="checkbox" className="form-checkbox" checked={isSelected} onChange={() => onChange(airportCode, !isSelected)} />
            {airportName}
        </label>
    </div>)
}

const DeparturePicker = ({ selectedAirports, onUpdate, updateOverviewText }) => {
    const [availableDepAirs, setAvailableDepAirs] = useState(null);
    const [filterText, setFilterText] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const dataSource = useContext(DataSourceContext);
    const isMobile = useContext(IsMobileContext);

    useEffect(() => {
        async function fetchData() {
            setAvailableDepAirs(null)
            var departureAirports = await dataSource.getDepartures();
            setAvailableDepAirs(departureAirports);
        }
        fetchData();
    }, [dataSource]);

    useEffect(() => {
        updateOverviewText(buildDepartureText());
    }, [selectedAirports, availableDepAirs,dataSource]);


    const onDepartureChange = (code, isSelected) => {
        setFilterText("");
        if (isSelected) {
            onUpdate([...selectedAirports, code]);
        } else {
            var newAirportList = selectedAirports.filter((item) => item !== code);
            onUpdate(newAirportList);
         }

    }
    const buildDepartureText = () => {
        let inputText = "";
        //HasLoaded
        if (availableDepAirs) {

            var verifiedSelectedAir = [];
            for (let index = 0; index < selectedAirports.length; index++) {
                const myCode = selectedAirports[index];
                var found = availableDepAirs.find((item) => item.code == myCode);
                if (found) {
                    verifiedSelectedAir.push(found.name);
                }
            }

            if (verifiedSelectedAir.length == 1) {
                inputText = verifiedSelectedAir[0];
            } else if (verifiedSelectedAir.length > 1) {

                inputText = verifiedSelectedAir[0] + " +" + (verifiedSelectedAir.length - 1);

            } else {
                inputText = "Departing From";
            }

        } else {
            inputText = "Loading...";
        } return inputText;

    }

    const toggleAirports = (codes) => {
        var validCodes = [];
        if (areAllValidSelected(codes)) {
            //unselect
            validCodes = selectedAirports.filter((x) => !codes.includes(x));
        }
        else {
            var currentSelected = [...selectedAirports, ...codes.filter((x) => availableDepAirs.find((item) => item.code == x) || selectedAirports.includes(x))];
            currentSelected= [...new Set(currentSelected)];
            validCodes = currentSelected;
        }
        onUpdate(validCodes);
        updateOverviewText(buildDepartureText())
    }
    const areAllValidSelected = (codes) => {
        if (availableDepAirs) {
            var validCodes = codes.filter((x) => availableDepAirs.find((item) => item.code == x));

            return validCodes.every(element => selectedAirports.includes(element));
        }
        return false;
    }
    let filteredAirports = [];

    let inputText = "Departure Airport";
    if (availableDepAirs) {

        inputText = buildDepartureText();
        if (filterText) {
            filteredAirports = availableDepAirs.filter((item) => item.name.toLowerCase().includes(filterText.toLowerCase()) || item.code.toLowerCase() == filterText.toLowerCase());
        } else {
            filteredAirports = availableDepAirs;
        }
    }

    return <PopoverInput footer={<DepartureFooter selectAirports={selectedAirports} close={() => setIsOpen(false)} />} inputText={inputText} isLoading={availableDepAirs == null} onTextUpdate={setFilterText} filterText={filterText} doubleWidth={true} isOpen={isOpen} setIsOpen={setIsOpen}>
        <div className={"grid grid " + (isMobile ? "grid-cols-1" : "grid-cols-2")}>

            <div className="form-checkbox-wrapper hover:bg-content_5 rounded-[8px] mr-2 text-content_2">
                <label className="form-checkbox-label-left ">
                    <input type="checkbox" className="form-checkbox" checked={areAllValidSelected(["LGW", "STN", "LCY", "LHR", "LTN", "STN"])} onChange={() => toggleAirports(["LGW", "STN", "LCY", "LHR", "LTN", "STN"])} />
                    All London
                </label>
            </div>

            {filteredAirports?.map((x, i) => {
                return <SelectItem airportCode={x.code} airportName={x.name} key={i} isSelected={selectedAirports.includes(x.code)} onChange={onDepartureChange} />
            })}
        </div>
    </PopoverInput>
}
export default DeparturePicker;
